'use strict';

/**
 * Returns the appropriate autocomplete attribute value based on the current browser.
 *
 * Firefox respects `autocomplete="off"` but ignores non-standard tokens.
 * Chrome ignores `autocomplete="off"` but respects non-standard tokens.
 *
 * The exception is the email type field, with Chrome respecting `autocomplete="off"`
 *
 * @returns {string} "off" for Firefox, "nop" for other browsers (e.g. Chrome)
 */
function getAutocompleteValue() {
    return navigator.userAgent.includes('Firefox') ? 'off' : 'nop';
}

module.exports = {
    getAutocompleteValue: getAutocompleteValue
};
